/**
 * HTTP layer for shipping types. The carrier/service options a shipment can use.
 *
 * Contains:
 * - fetchShippingTypes / fetchShippingType: reads
 * - postShippingType / patchShippingType / deleteShippingType: writes
 */
import apiClient from '@sophocles/http-common';

const SHIPPING_TYPE_ENDPOINT = '/warehouse/shipping-types';

export const fetchShippingTypes = queryParams =>
  apiClient.get(`${SHIPPING_TYPE_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchShippingType = shippingTypeId =>
  apiClient.get(`${SHIPPING_TYPE_ENDPOINT}/${shippingTypeId}/`).then(res => res.data);

export const postShippingType = data => apiClient.post(`${SHIPPING_TYPE_ENDPOINT}/`, data).then(res => res.data);

export const patchShippingType = (shippingTypeId, data) =>
  apiClient.patch(`${SHIPPING_TYPE_ENDPOINT}/${shippingTypeId}/`, data).then(res => res.data);

export const deleteShippingType = shippingTypeId => apiClient.delete(`${SHIPPING_TYPE_ENDPOINT}/${shippingTypeId}/`);
